<template>
  <v-menu :disabled="readonly">
    <template #activator="{ on: menu }">
      <div style="position: relative; cursor: pointer !important">
        <div v-if="readonly">
          <slot></slot>
        </div>
        <div v-else v-on="menu">
          <slot></slot>
        </div>
        <i style="color: grey; position: absolute; right: 10px; top: 8px" class="fas fa-chevron-down"></i>
      </div>
    </template>
    <v-list style="max-height: 400px; overflow: auto">
      <template v-if="statustype">
        <v-list-tile dense class="rsu" v-for="(item, index) in filteredOptions" :key="index" @click="selectedMenu(index)">
          <v-list-tile-title :style="`color: ${statusColor(item)}`">{{
            statusLabel(item)
          }}</v-list-tile-title>
        </v-list-tile>
      </template>
      <template v-else-if="projectstatustype">
        <v-list-tile dense class="rsu" v-for="(item, index) in filteredOptions" :key="index" @click="selectedMenu(index)">
          <v-list-tile-title :style="`color: ${projectStatusColor(item)}`">{{
            projectStatusLabel(item)
          }}</v-list-tile-title>
        </v-list-tile>
      </template>
      <template v-else-if="checktype">
        <v-list-tile dense class="rsu" v-for="(item, index) in filteredOptions" :key="index" @click="selectedMenu(index)">
          <v-list-tile-title :style="`color: ${checkColor(item)}`">{{
            checkLabel(item)
          }}</v-list-tile-title>
        </v-list-tile>
      </template>
      <template v-else-if="nametype">
        <v-list-tile dense class="rsu" v-for="(item, index) in filteredOptions" :key="index" @click="selectedMenu(index)">
          <v-list-tile-title :style="{ 'color':'#26588B','font-weight': '400px'}">
          {{item.name}}
          </v-list-tile-title>
        </v-list-tile>
      </template>
      <template v-else>
        <v-list-tile dense class="rsu v-list-tile-hover" v-for="(item, index) in filteredOptions" :key="index"
          @click="selectedMenu(index)">
          <v-list-tile-title :style="{ 'color': colorRed ? '#F10606' : '#26588B','font-weight': '400px'}">{{ item }}</v-list-tile-title>
        </v-list-tile>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    textLabel: {
      type: String,
      default: null,
    },
    textValue: {
      type: String,
      default: null,
    },
    readonly: {
      default: false,
    },
    statustype: {
      default: false,
    },
    projectstatustype: {
      default: false,
    },
    checktype: {
      default: false,
    },
    nametype: {
      default: false,
    },
    colorRed: {
      default: false,
    },
  },
  computed: {
    filteredOptions() {
      if (this.textLabel) {
        return this.options.map((el) => {
          return el[this.textLabel]
        })
      } else {
        return this.options
      }
    },
  },
  methods: {
    statusColor(item) {
      if (item == 'confirm') {
        return '#67AD5B'
      } else if (item == 'unconfirmed') {
        return '#818181'
      } else if (item == 'rejected') {
        return '#F10606'
      } else if (item == 'pending') {
        return '#FF8A00'
      } else return item
    },
    checkColor(item) {
      if (item == 'uncheck') {
        return '#F10606'
      } else if (item == 'waitingdocument') {
        return '#FF8A00'
      } else if (item == 'sentcheck') {
        return '#FF8A00'
      } else if (item == 'checked') {
        return '#67AD5B'
      } else return item
    },
    projectStatusColor(item) {
      if (item == 'rejected') {
        return '#F10606'
      } else if (item == 'unconfirmed') {
        return '#F10606'
      } else if (item == 'pending') {
        return '#FF8A00'
      } else if (item == 'confirm') {
        return '#67AD5B'
      } else return item
    },
    statusLabel(item) {
      if (item == 'confirm') {
        return 'ตรวจสอบแล้ว' // 'Verified'
      } else if (item == 'unconfirmed') {
        return 'ยังไม่ตรวจสอบ' //'Waiting'
      } else if (item == 'rejected') {
        return 'ปฏิเสธการยืนยันตัวตน' //'Rejected'
      } else if (item == 'pending') {
        return 'รออนุมัติ' // 'Pending'
      } else return item
    },
    projectStatusLabel(item) {
      if (item == 'confirm') {
        return 'อนุมัติแล้ว'
      } else if (item == 'unconfirmed') {
        return 'ยังไม่ได้ตรวจสอบ'
      } else if (item == 'rejected') {
        return 'ไม่อนุมัติ'
      } else if (item == 'pending') {
        return 'อยู่ระหว่างพิจรณา'
      } else return item
    },
    checkLabel(item) {
      if (item == 'uncheck') {
        return 'ยังไม่ได้ตรวจสอบ' // 'uncheck'
      } else if (item == 'waitingdocument') {
        return 'รอเอกสาร' //'waitingdocument'
      } else if (item == 'sentcheck') {
        return 'ส่งตรวจสอบ' //'sentcheck'
      } else if (item == 'checked') {
        return 'ตรวจสอบแล้ว' //'checked'
      } else return item
    },
    selectedMenu(index) {
      if (!this.readonly) {
        if (this.textValue) {
          this.$emit('input', this.options[index][this.textValue])
          this.$emit('changeInput')
        } else if (this.nametype){
          this.$emit('input', this.options[index].name)
          this.$emit('changeInput')
          this.$emit('idSelect',this.options[index].id)
        }else {
          this.$emit('input', this.options[index])
          this.$emit('changeInput')
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/elements/DropdownMenu.vue